(function () {
  'use strict';
  var template = document.getElementById('ig-id39-template');
  if (!template || template.dataset.pageType !== 'page') return;
  // Exact purchase-heading groups audited against live Replo components.
  // The missing-layer component is also reused by the native mg-lp section.
  var groups = [
    // barn-secret-v2
    ["d8b46a3a-1e51-488f-b5a1-df5390b41d8e", "65a314b7-d4a9-43b9-9c8a-abc9451c1d46", "b22e2ce8-87fb-41d9-8867-a5d7f98a19eb", "8a0b5cd0-e322-4957-b55a-ba3e63ef1b86"],
    // leg-recovery
    ["43af42c9-ab1a-4d99-8f10-bc9b938fb28a", "6ef32d9f-6728-4563-aeff-a5ee29050dbe", "d5827580-2719-4019-ac3b-f9e77c197e7e", "8bd605b8-3d63-43e4-b55c-d3023cf57dfc"],
    // tightness
    ["79d13917-4880-48f1-a285-0913f0232c89", "a131cf38-b7b6-48ab-ad25-f7c751979fd8", "2466417f-d713-4ea1-935e-a5bd090595d1", "663adb56-b26a-4939-8b6c-04cb35da776a"],
    // aging
    ["9233e235-88ef-41c4-83aa-deb738f390b8", "48efec41-8a0f-4291-8e68-b5c609b9f1ba", "b075c86c-2119-40b9-af18-4a925192837c", "136b6001-2e9b-45f2-b08f-167aa699b6e1"],
    // barn-secret
    ["955aae34-aa0d-40c4-8179-e2de75daa2ca", "d666d3c7-d7be-4714-a8d9-38e68fd978f2", "1c1a78cf-60c8-49b6-a84f-7aade76ce642", "e53ea6f4-9576-40d2-8760-d7180338a012"],
    // hock-stiffness
    ["61578797-2ebf-46e2-9d41-1f591f986de8", "a1273c56-f3d6-45cc-a6db-35a1e881fee4", "b7c610bc-4476-493b-82f2-dac93478fbe4", "7d522718-90cb-4333-9061-8d91d8cf1d20"],
    // haloback
    ["992274f7-2629-4377-8531-6e28d6a57a93", "cec09b6c-3a92-42a4-af03-7ca6266c2352", "5669a9b6-a851-4746-9963-89e31026f6ed", "9952b60b-0e06-4482-a3b1-970f59e48225"],
    // grateful-v2
    ["74b1a7ff-8f66-4e05-aae8-9bd76f335e59", "d8f57be5-c305-4ac0-af1a-57321f8b48d4", "74ec53de-aa31-4bd9-a09f-d7440ee7a4f6", "7f269577-25f6-4a6d-9af1-28018195303b"],
    // hock-tightness
    ["98d3ac7a-1fbc-4c90-84da-858b1c180bde", "9d325787-a54c-4f58-8670-2eaf116346f9", "b56e594d-fa70-4bb2-ba06-8038b74da2de", "cb55aeca-36b3-43ff-a9e9-94de8c63c082"],
    // the-missing-layer
    ["dd29e0e1-bc1a-4920-8108-67fcb00b550f", "8c8c335c-1b06-4963-b0e6-5a791d33328a", "4fde0ffd-7dd3-46a0-972a-707f57cdf87c", "cd4f7950-357e-49c2-8cc5-5a5fd57db810"],
    // grateful
    ["3ae9002f-deef-4967-96d4-d5cd65bcf7c7", "7a2f3796-2992-4bcf-b447-2467a03f7901", "d22c2159-3bb8-41fa-bf03-10e88056324b", "1ceec3ba-ed42-430d-8caf-b753353135bc"],
    // joints
    ["abc73968-8a7a-4c16-92ad-ba482fa0c645", "42c959cc-a04f-4ab0-8eea-3d7f80d2d106", "7b39db2d-52b0-49c9-ac0b-31622f12bf60", "bd98a881-867c-4a39-886e-bbb6ab7083dd"],
    // tension
    ["cb4a4f1f-1c99-462d-aab0-5c3634ab2c55", "acbc5f04-2e2b-4769-ac18-d05c322e87ba", "dc729126-f0c9-4a6f-8eba-c90822d8abc8", "b0be6712-7951-40e9-a8ef-e71a24f61327"],
    // hlm-med-angle
    ["d1239777-29f4-4b24-8247-3ca061edae45", "7d443395-c769-4fc8-b3d1-8c9577ee9972", "9ebfb414-39cb-4a86-b79e-2dc359959022", "bc6db76e-43cc-4293-9467-39e38024e45b"],
    // backpad
    ["e5a1d4c6-1444-4a11-ad9f-5fd4789834a2", "de7886c1-cfdc-438e-bf2a-57db3832cc71", "32206354-ea1f-4bae-8b53-80cc814bae4b", "de850115-bee5-4a68-af0e-ef1846771b3c"]
  ];
  var reviews = {};
  var data = document.getElementById('ig-id39-product-reviews');
  if (data) {
    try { reviews = JSON.parse(data.textContent); } catch (error) { reviews = {}; }
  }
  function mark(node, key, value) {
    if (node && node.getAttribute(key) !== value) node.setAttribute(key, value);
  }
  function rid(root, value) { return root.querySelector('[data-rid="' + value + '"]'); }
  function prepareRating(rating, label, handle) {
    if (!rating) return;
    mark(rating, 'data-ig-id39-source-rating', '');
    var stats = reviews[handle];
    if (!label || !stats || !Number.isFinite(stats.rating) || stats.rating <= 0 || stats.rating > 5 || !Number.isInteger(stats.count) || stats.count <= 0) return;
    mark(label, 'data-ig-id39-source-label', '');
    mark(rating, 'data-rating', String(stats.rating));
    mark(rating, 'data-raters', String(stats.count));
  }
  window.igId39PrepareLandings = function () {
    groups.forEach(function (group) {
      document.querySelectorAll('[data-rid="' + group[0] + '"]').forEach(function (box) {
        var product = box.closest('[data-replo-product-handle]');
        var handle = product && product.getAttribute('data-replo-product-handle');
        var title = rid(box, group[1]);
        var rating = rid(box, group[2]);
        // Empty placeholder products and unrelated editorial headings stay untouched.
        if (!handle || !title || !rating || title.parentElement !== box || rating.parentElement !== box) return;
        mark(box, 'data-ig-id39-container', '');
        mark(box, 'data-ig-id39-presentation', 'css');
        mark(box, 'data-product-handle', handle);
        mark(title, 'data-ig-id39-source-title', '');
        var label = rid(rating, group[3]);
        // Keep Replo typography and surrounding click handlers on their existing nodes.
        if (label) label = label.querySelector('p') || label;
        prepareRating(rating, label, handle);
      });
    });
    document.querySelectorAll('.product__info-container[data-product-handle]').forEach(function (box) {
      if (box.querySelector('.loox-rating, [data-ig-id39-container]')) return;
      var rating = box.querySelector('.hhlist-bbrating, .rating-stars');
      var label = rating && (rating.querySelector('.rating-stars__label a') || rating.querySelector('.rating-stars__label') || rating.querySelector(':scope > span:last-child'));
      prepareRating(rating, label, box.getAttribute('data-product-handle'));
    });
  };
})();
